import Board from "components/Common/Board/Board";
import styled from "styled-components";

const TagPageBoard = styled(Board)`
  width: 100rem;
  padding: 5rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  h1 {
    ${({ theme }) => theme.typography.h1.bold}
  }
`;

export default TagPageBoard;
